// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"388b2be9","590":"388b2be9","617":"388b2be9","820":"cc46d0f6","989":"8e3c3bfd"}[chunkId] + ".chunk.css";
};